import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'pluralize' })
export class PluralizePipe implements PipeTransform {
  transform(value: number | string): string {
    const number = value as number;
    return number > 1 ? 's' : '';
  }
}
